import React from 'react';

import { useDebouncedCallback } from 'use-debounce';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

const boxStyles = cssMap({
	wrapperStyles: {
		boxSizing: 'border-box',
	},
});

const HOVER_OUT_TIMEOUT = 400; // ms

export type HoverOffWrapperProps = {
	callback: () => void;
	children: React.ReactNode;
	enabled?: boolean;
};

const HoverOutWrapper = ({ callback, children }: Omit<HoverOffWrapperProps, 'enabled'>) => {
	const [handleHoverChange] = useDebouncedCallback((hoveringOn: boolean) => {
		if (!hoveringOn) {
			callback();
		}
	}, HOVER_OUT_TIMEOUT);

	return (
		<Box
			onMouseEnter={() => handleHoverChange(true)}
			onMouseLeave={() => handleHoverChange(false)}
			xcss={boxStyles.wrapperStyles}
		>
			{children}
		</Box>
	);
};

export const MaybeHoverOutWrapper = ({ enabled = false, ...rest }: HoverOffWrapperProps) => {
	if (!enabled) {
		return <>{rest.children}</>;
	}

	return <HoverOutWrapper {...rest} />;
};
